// Background Space + Desktop layer (build review NOV.01.2026, task 4).
//
// Renders the routed background page (OP1Web/homepage, OP1Web/forum, ...)
// and, on top of it, the OP1Web desktop layer (windows + dock) as a
// click-through overlay. The overlay is mounted ONCE for all background
// routes (React Router layout route + <Outlet/>), so switching the
// background with an OP1WebBgSpaceButton never re-creates the windows or
// the dock - they stay exactly as they are.
import React from "react";
import { Outlet } from "react-router-dom";
import Op1WebDesktopLayer from "./Op1WebDesktopLayer";
import "./DesktopLayerLayout.css";

export default function DesktopLayerLayout() {
  return (
    <>
      <div className="op1BackgroundSpace">
        <Outlet />
      </div>
      <div className="op1DesktopOverlay">
        <Op1WebDesktopLayer />
      </div>
    </>
  );
}
